

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>


<br>
<br>
<br>


<!-- Terms And Conditions Hero Section -->
<section class="privacy-hero">
  <div class="hero-overlay">
    <h1>Terms And Conditions</h1>
  </div>
</section>

<!-- Terms And Conditions Content Section -->
<section class="privacy-content container">
  <div class="policy-section">
    <h2>1. Acceptance </h2>
    <p>
    By accessing or using the Facheck platform (https://facheck.in & https://facheck.biz) and the services provided by Baabuji Venturess (“Company”, “we”, “our”, “us”), you (“User” or “Client”) acknowledge that you have read, understood, and agree to be legally bound by these Terms and Conditions (“Terms”). If you are using the Platform on behalf of an organization, you represent and warrant that you are duly authorized to bind such organization to these Terms. If you do not agree with any part of these Terms, you must refrain from using the Platform and its services. 

 

    </p>


  </div>

  <div class="policy-section">
    <h2>2. Services </h2>
    <p>
     The Company provides a technology platform offering API-based digital KYC verification services, digital document signing using RSA 256 encryption, and a dashboard interface for monitoring usage, analytics, and billing management. The Platform also facilitates prepaid wallet-based transactions and postpaid billing arrangements. The Company operates strictly as a technology intermediary and facilitator, enabling secure transmission of data between Clients and authorized third-party or government verification systems. The Company does not own, control, or verify the underlying data sources and does not guarantee the accuracy, completeness, or reliability of any verification results. 

 
    </p>
 
  </div>

  <!-- Repeat sections for 3 to 15 with similar structure -->
  <div class="policy-section">
    <h2>3. Account & Access </h2>
    <p>To access the services, Users are required to create and maintain an account with accurate and up-to-date information. Users are solely responsible for maintaining the confidentiality of their login credentials, API keys, and authentication mechanisms. The Platform enforces mandatory Two-Factor Authentication (2FA) to enhance account security. Any activity carried out under a User’s account shall be deemed to have been authorized by the User. In the event of unauthorized access or suspected security compromise, the User must notify the Company immediately. The Company reserves the right to suspend or restrict access to any account in the event of suspicious activity, security threats, or violations of these Terms. 

 </p>
 

  </div>

  <div class="policy-section">
    <h2>4. API Usage </h2>
    <p>Subject to compliance with these Terms, the Company grants the User a limited, non-exclusive, non-transferable, and revocable license to access and use the APIs solely for lawful business purposes. Users agree not to misuse the APIs in any manner, including but not limited to engaging in fraudulent activities, violating applicable laws, attempting to reverse engineer or replicate the services, or bypassing security controls. The User shall not use the Platform for unauthorized data harvesting, bulk extraction, or resale of services without prior written consent. The Company reserves the right to impose rate limits and monitor usage to ensure fair usage and system integrity. Users are solely responsible for the accuracy, legality, and consent associated with the data they submit through the APIs. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>5. Payment Terms </h2>
    <p>The Platform operates on both prepaid and postpaid billing models. Under the prepaid model, Users are required to maintain sufficient wallet balance to access services, failing which the services may be automatically suspended. All wallet top-ups are final and non-transferable except as otherwise stated in the refund policy. Under the postpaid model, which is subject to approval by the Company, Users are billed based on actual usage and must settle invoices within the specified due dates. Failure to make timely payments may result in suspension or termination of services and may attract penalties or legal recovery actions. All payments are processed through RBI-authorized, PCI-DSS compliant payment gateways, and the Company does not store sensitive payment information. </p>
    

    
  </div>

  <div class="policy-section">
    <h2>6. Service Availability  </h2>
    <p>While the Company endeavors to maintain high service availability and performance standards, it does not guarantee uninterrupted or error-free operation of the Platform. Users acknowledge that the services depend significantly on third-party providers, including government systems and external verification sources, and may be subject to delays, downtime, or inaccuracies beyond the Company’s control. Scheduled maintenance, system upgrades, and unforeseen technical issues may also result in temporary service interruptions. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>7. Limitation of Liability </h2>
    <p>To the fullest extent permitted under applicable law, the Company shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in connection with the use of the Platform. This includes, but is not limited to, errors or inaccuracies in verification data, delays in service delivery, loss of business, loss of profits, or decisions made by Users based on the data obtained through the Platform. The Company shall also not be liable for any issues arising from incorrect or incomplete data submitted by Users or failures of third-party systems. In any event, the total liability of the Company shall be limited to the amount paid by the User for the services during the immediately preceding billing cycle. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>8. Indemnity </h2>
    <p>The User agrees to indemnify, defend, and hold harmless the Company, its directors, employees, affiliates, and partners from and against any claims, liabilities, damages, losses, or expenses arising out of or related to the User’s misuse of the Platform, violation of these Terms, non-compliance with applicable laws, or unauthorized or unlawful processing of personal data. This includes any claims arising from failure to obtain proper consent from end users or misuse of verification data. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>9. Termination </h2>
    <p>The Company reserves the right to suspend or terminate access to the Platform at its sole discretion, with or without prior notice, in the event of violation of these Terms, non-payment of dues, security risks, or regulatory requirements. Users may discontinue use of the services at any time and request account closure. Upon termination, all outstanding payments shall become immediately due, and access to the Platform will be revoked. No refunds shall be provided except as explicitly stated in the applicable policies. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>10. Intellectual Property</h2>
    <p>All intellectual property rights related to the Platform, including but not limited to software, APIs, design, structure, documentation, and branding, are the exclusive property of Baabuji Venturess. Users are granted only a limited right to use the services as per these Terms and shall not copy, reproduce, distribute, modify, or create derivative works without prior written consent from the Company. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>11. Data Protection & Compliance </h2>
    <p>Users agree to comply with all applicable data protection and privacy laws, including the Digital Personal Data Protection Act, 2023, the Information Technology Act, 2000, and any applicable RBI, UIDAI, or KYC/AML regulations. Users are solely responsible for obtaining explicit and informed consent from end users before submitting their data for verification. The Company acts only as a data processor and shall not be responsible for any non-compliance by the User. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>12. Confidentiality </h2>
    <p>Both parties agree to maintain strict confidentiality of any proprietary, technical, or business information exchanged in connection with the use of the Platform. Such information shall not be disclosed to any third party without prior written consent, except where required by law or regulatory authorities. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>13. Force Majeure </h2>
    <p>The Company shall not be held liable for any failure or delay in performance resulting from events beyond its reasonable control, including but not limited to natural disasters, acts of government, cyber-attacks, network failures, or disruptions in third-party services. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>14. Modifications to Terms  </h2>
    <p>The Company reserves the right to modify or update these Terms at any time. Any changes will be posted on the Platform and shall become effective immediately upon publication. Continued use of the services after such updates constitutes acceptance of the revised Terms. </p>
    
    
  </div>



  <!-- Continue with all sections until 15. Contact -->
  <div class="policy-section">
    <h2>15. Governing Law & Jurisdiction </h2>
    <p>
      These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the courts located in Chennai, Tamil Nadu. 
    </p>
    
  </div>

  <div class="policy-section">
    <h2>16. Dispute Resolution  </h2>
    <p>
      In the event of any dispute, the parties shall first attempt to resolve the matter amicably through mutual discussions. If such resolution is not achieved within a reasonable period, the dispute shall be referred to the competent courts as specified above. 
    </p>
    
  </div>

  <div class="policy-section">
    <h2>17. Entire Agreement </h2>
    <p>
      These Terms constitute the entire agreement between the User and the Company with respect to the use of the Platform and supersede all prior agreements, communications, or understandings, whether written or oral. 

    </p>
    
  </div>
</section>


